/* eslint-disable */
import React from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { Metadata } from '@thd-olt-component-react/metadata';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';

export const PIPPageContainer = ({ children }) => {
  const { isCustomerIdentified = false } = useThdCustomer() || {};
  const store = useStore();
  const { storeId, storeZip, membershipInformation = null, isLocalized } = store;

  const merge = {
    productClientOnlyProduct: {
      queries: ['product', 'clientOnlyProduct'],
      fn: ({ query, mounted }) => {
        if (!mounted) return query;

        if (query === 'product' || query === 'clientOnlyProduct') {
          return 'productClientOnlyProduct';
        }
        return query;
      },
    },
  };

  const defaultVariables = {
    storeId,
    skipSubscribeAndSave: false,
    zipCode: storeZip,
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1,
    maxItems: 6,
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null,
    },
    isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false,
    loyaltyMembershipInput: null
  };

  if (membershipInformation?.data?.loyaltyMembership) {
    defaultVariables.loyaltyMembershipInput = membershipInformation.data.loyaltyMembership;
  }

  return (
    <Metadata>
      <QueryProvider cacheKey="page" defaultVariables={defaultVariables} fusion merge={merge}>
        {children}
      </QueryProvider>
    </Metadata>
  );
};

PIPPageContainer.propTypes = {};

PIPPageContainer.displayName = 'PIPPageContainer';

PIPPageContainer.defaultProps = {};
